"use client";

import { Carousel } from "nuka-carousel";
import type { ReactNode } from "react";

export default function FeaturedCarousel<T>({
  title,
  items,
  getKey,
  renderItem,
  compact = false,
}: {
  title: string;
  items: readonly T[];
  getKey: (item: T) => string;
  renderItem: (item: T, index: number) => ReactNode;
  compact?: boolean;
}) {
  return (
    <Carousel
      title={title}
      showArrows="always"
      wrapMode="wrap"
      scrollDistance="slide"
      className="w-full"
    >
      {items.map((item, index) => (
        <div
          key={getKey(item)}
          className={`h-full shrink-0 px-2 py-4 ${compact ? "w-[18rem]" : ""}`}
        >
          {renderItem(item, index)}
        </div>
      ))}
    </Carousel>
  );
}
